import colors from "./Colors.json"

class Warna {
  constructor(name, prop) {
    this.name = name
    this.prop = prop
  }
}

export default Object.keys(colors)
  .map(key => new Warna(key, colors[key]))
  .reduce((object, warna) => {
    object[warna.name] = warna
    return object
  }, {})



// WEBPACK FOOTER //
// ./src/data/Colors.js